import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, formatErr } from "@/lib/api";

const when = (iso) => new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

const FeedRow = ({ post, onPost, onComment }) => (
  <article className="card-soft p-6" data-testid={`admin-feed-post-${post.id}`}>
    <div className="flex items-start justify-between gap-4">
      <div>
        <p className="text-sm"><span className="font-semibold">{post.name}</span> <span className="text-[#232b1b]/50">· {when(post.created_at)}</span>{post.pinned && <span className="ml-2 text-[11px] uppercase tracking-widest text-[#b6689a]">Pinned</span>}</p>
        <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-[#232b1b]/85">{post.body}</p>
      </div>
      <button onClick={() => onPost(post)} className="btn btn-ghost !py-1.5 !px-4 text-xs shrink-0" data-testid={`admin-feed-delete-${post.id}`}><Trash2 size={14} /> Remove post</button>
    </div>
    {post.comments.length > 0 && (
      <ul className="mt-4 pl-6 space-y-2">
        {post.comments.map((c, i) => (
          <li key={c.id || i} className="flex items-start justify-between gap-3 rounded-2xl bg-[#dacac1]/35 px-4 py-2.5 text-sm" data-testid={`admin-feed-comment-${c.id || i}`}>
            <span><span className="font-semibold">{c.name}</span> {c.body}</span>
            {c.id && <button onClick={() => onComment(post, c)} className="text-xs text-[#9c3d5c] underline shrink-0" data-testid={`admin-feed-comment-delete-${c.id}`}>Remove</button>}
          </li>
        ))}
      </ul>
    )}
  </article>
);

export const AdminFeed = () => {
  const [posts, setPosts] = useState(null);
  const load = () => api.get("/admin/feed").then((r) => setPosts(r.data));
  useEffect(() => {
    load();
  }, []);

  const removePost = async (p) => {
    if (!window.confirm(`Remove this post by ${p.name} and all its comments?`)) return;
    try {
      await api.delete(`/admin/feed/${p.id}`);
      toast.success("The post has been gently removed from the circle.");
      load();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  const removeComment = async (p, c) => {
    if (!window.confirm(`Remove this comment by ${c.name}?`)) return;
    try {
      await api.delete(`/admin/feed/${p.id}/comments/${c.id}`);
      toast.success("The comment has been gently removed.");
      load();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };

  if (!posts) return null;
  if (!posts.length) return <p className="text-[#232b1b]/60">The feed is quiet. Nothing to tend right now.</p>;
  return (
    <div className="space-y-5" data-testid="admin-feed">
      {posts.map((p) => <FeedRow key={p.id} post={p} onPost={removePost} onComment={removeComment} />)}
    </div>
  );
};
